export * from "./PromotionTable";
